var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart_wrapper"},[_c('highcharts',{staticClass:"hc",staticStyle:{"width":"100%","height":"400px","margin-left":"30px","margin-right":"30px"},attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }